import * as React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import { noop } from 'lodash';
import { Icon, Modal, Select, Table } from 'antd';

import { searchUsers, searchGroups } from 'Root/http';
import Search from 'shared/components/Search/Search';
import Loader from 'shared/components/Loader/Loader';

import s from './style/AddUserModal.pcss';


const userSearchColumns = [{
  title: 'Имя',
  dataIndex: 'fullName',
  width: '25%',
  render: (text, record) => (
    <div className={s.nameContainer}>
      <div className={s.name}>{text}</div>
      {record.tags &&
        <div className={s.tagList}>
          {record.tags.map(tag => (
            <div key={tag} className={s.tagItem}>{tag}</div>
          ))}
        </div>
      }
    </div>
  ),
},
{
  title: 'E-mail',
  dataIndex: 'email',
  width: '25%',
},
{
  title: 'Должность',
  dataIndex: 'positionName',
  width: '25%',
  render: text => text || 'Не известно',
},
{
  title: 'Подразделение',
  dataIndex: 'fetch.unitId.unitId.name',
  width: '25%',
  render: text => text || 'Не известно',
}];

const groupSearchColumns = [{
  title: 'Название группы',
  dataIndex: 'name',
  render: text => (
    <div className={s.nameContainer}>
      <div className={s.name}>{text}</div>
    </div>
  ),
}];

const SEARCH_TYPE_BY_USER_NAME = 'SEARCH_TYPE_BY_USER_NAME';
const SEARCH_TYPE_BY_GROUP_NAME = 'SEARCH_TYPE_BY_GROUP_NAME';


export default class AddUserModal extends React.Component {
  static propTypes = {
    visible: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.shape().isRequired,
    users: PropTypes.arrayOf(PropTypes.string).isRequired,
    filters: PropTypes.arrayOf(PropTypes.string),
    onAddUsers: PropTypes.func.isRequired,
    onAddGroups: PropTypes.func,
    withGroups: PropTypes.bool,
    onlyUsers: PropTypes.bool,
  };

  static defaultProps = {
    withGroups: true,
    onlyUsers: false,
    onAddGroups: noop,
    filters: [],
  };


  state = {
    data: [],
    selected: [],
    searchValue: '',
    page: 1,
    total: 0,
    searchField: SEARCH_TYPE_BY_USER_NAME,
    loading: false,
    saving: false,
  };


  componentWillReceiveProps(nextProps) {
    if (this.props.visible && !nextProps.visible) {
      this.setState({
        data: [],
        selected: [],
        searchValue: '',
        total: 0,
        page: 1,
        searchField: SEARCH_TYPE_BY_USER_NAME,
      });
    }
  }

  onSelectChange = selected => this.setState({ selected });

  cancelSelection = () => this.setState({ selected: [] });

  handleSearch = (value) => {
    if ((!value || value.length < 2)) return;

    this.setState({ loading: true, searchValue: value }, () => {
      const { searchField } = this.state;
      const searchData = { value };

      if (searchField === SEARCH_TYPE_BY_USER_NAME) {
        searchUsers(searchData, this.props.filters).then((data) => {
          const filteredUsers = data.list.filter(user => !this.props.users.includes(user.id));
          this.setState({ data: filteredUsers, total: data.pageInfo.tableSize, loading: false });
        });
      } else {
        searchGroups(searchData).then((data) => {
          const groupsResponseTransformed = data.list.reduce(
            (resultGroupsList, group) => (group.obj ? resultGroupsList.concat(group.obj) : resultGroupsList),
            [],
          );
          this.setState({ data: groupsResponseTransformed, total: data.pageInfo.tableSize, loading: false });
        });
      }
    });
  };

  onSelectSearchFieldType = (value) => {
    this.setState({ searchField: value }, () => this.handleSearch(this.state.searchValue));
  };

  addUsers = () => {
    const { onAddUsers, onAddGroups } = this.props;
    const { searchField, selected = [] } = this.state;

    this.setState({ saving: true }, () => {
      switch (searchField) {
        case SEARCH_TYPE_BY_USER_NAME: {
          onAddUsers(selected).then(() => {
            this.setState({ saving: false });
          });

          break;
        }

        case SEARCH_TYPE_BY_GROUP_NAME: {
          onAddGroups(selected).then(() => {
            this.setState({ saving: false });
          });

          break;
        }

        default: break;
      }
    });
  };

  changePage = ({ current }) => this.setState({ page: current });


  render() {
    const { onClose, visible, title, withGroups, onlyUsers } = this.props;
    const { data, searchValue, selected, saving, searchField } = this.state;

    const rowSelection = {
      selectedRowKeys: selected,
      onChange: this.onSelectChange,
    };
    const modalTitle = withGroups
      ? 'Добавить пользователей к роли'
      : 'Добавить пользователей в группу';

    const loading = {
      spinning: this.state.loading,
      indicator: <Loader fullScreen={false} size={20} />,
    };

    return (
      <div>
        <Modal
          title={modalTitle}
          footer={null}
          visible={visible}
          onCancel={onClose}
          destroyOnClose
          width={'930px'}
          bodyStyle={{
            height: '600px',
            overflow: 'hidden',
          }}
          getContainer={() => ReactDOM.findDOMNode(this)}
        >
          {title}
          <div className={s.controls}>
            <div className={s.controlsLabel}>
              <Icon onClick={this.cancelSelection} type="close" />
              &nbsp;
              {selected.length} значения выбрано
            </div>

            <div className={s.searchContainer}>
              <span>Искать по:</span>

              <Select
                size="small"
                className={s.searchContainer__select}
                value={searchField}
                onChange={this.onSelectSearchFieldType}
                disabled={onlyUsers}
              >
                <Select.Option value={SEARCH_TYPE_BY_GROUP_NAME}>По группам</Select.Option>
                <Select.Option value={SEARCH_TYPE_BY_USER_NAME}>По пользователям</Select.Option>
              </Select>

              <div className={s['searchContainer__search-wrapper']}>
                <Search onSearch={this.handleSearch} value={searchValue} />
              </div>
            </div>

            <div className={s.addContainer}>
              {selected.length > 0 && !saving ? (
                <div className={s.addBtn} onClick={this.addUsers}>Добавить</div>
              ) : null}
              {saving ? (
                <div className={s.savingLoader}>
                  <Loader size={20} fullScreen={false} />
                </div>
              ) : null}
            </div>
          </div>

          <div className={s.tableContainer}>
            <Table
              rowKey={r => r.id}
              rowSelection={rowSelection}
              pagination={{ current: this.state.page, total: this.state.total }}
              onChange={this.changePage}
              loading={loading}
              columns={searchField === SEARCH_TYPE_BY_USER_NAME ? userSearchColumns : groupSearchColumns}
              dataSource={data}
              scroll={{ y: 370 }}
            />
          </div>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Root/pages/shared/AddUserModal/AddUserModal.js